var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import ApproveDetails from '~/components/collection-manage/collection-application/approve-details.vue';
import { Emit, Prop } from 'vue-property-decorator';
import { SortService } from "~/utils/sort.service";
import { PageService } from '~/utils/page.service';
import { UserService } from '~/services/manage-service/user.service';
import DataBox from '~/components/common/data-box.vue';
var ReportcaseManageHandled = /** @class */ (function (_super) {
    __extends(ReportcaseManageHandled, _super);
    function ReportcaseManageHandled() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.reportcaseDataSet = [];
        _this.reportcaseselectionList = [];
        _this.SearchModel = {
            flowType: 'REPORT_CASE_APPLY',
            approvalStatus: 'APPROVED_COMPLETED',
        };
        _this.dialog = {
            approveDetail: false
        };
        _this.rowData = {};
        return _this;
    }
    ReportcaseManageHandled.prototype.refreshList = function () { };
    ReportcaseManageHandled.prototype.close = function () { };
    ReportcaseManageHandled.prototype.addNoteMeth = function (rowdata) { };
    ReportcaseManageHandled.prototype.checkNoteMeth = function (rowdata) { };
    ReportcaseManageHandled.prototype.approveDetail = function (row) {
        this.dialog.approveDetail = true;
        this.rowData = row;
    };
    ReportcaseManageHandled.prototype.refreshData = function () {
        var _this = this;
        this.SearchModel = Object.assign(this.SearchModel, this.reportcaseModel);
        this.SearchModel.applyDateStart = this.reportcaseModel.applyDate[0];
        this.SearchModel.applyDateEnd = this.reportcaseModel.applyDate[1];
        this.SearchModel.applyDate = '';
        this.caseApplyManageService.getProcessApproveMessage(this.SearchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.reportcaseDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    ReportcaseManageHandled.prototype.addNoteMethod = function (scope) {
        var rowData = scope.row;
        this.addNoteMeth(rowData);
    };
    ReportcaseManageHandled.prototype.checkNoteMethod = function (scope) {
        var rowData = scope.row;
        this.checkNoteMeth(rowData);
    };
    __decorate([
        Dependencies(SortService)
    ], ReportcaseManageHandled.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], ReportcaseManageHandled.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], ReportcaseManageHandled.prototype, "userService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], ReportcaseManageHandled.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit('refreshList')
    ], ReportcaseManageHandled.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], ReportcaseManageHandled.prototype, "close", null);
    __decorate([
        Emit('addNoteMeth')
    ], ReportcaseManageHandled.prototype, "addNoteMeth", null);
    __decorate([
        Emit('checkNoteMeth')
    ], ReportcaseManageHandled.prototype, "checkNoteMeth", null);
    __decorate([
        Prop()
    ], ReportcaseManageHandled.prototype, "reportcaseModel", void 0);
    ReportcaseManageHandled = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                ApproveDetails: ApproveDetails
            },
        })
    ], ReportcaseManageHandled);
    return ReportcaseManageHandled;
}(Vue));
export default ReportcaseManageHandled;
